import { sendTrackingEvent } from "./tracking_management";

const { NEXT_PUBLIC_APP_API_URL } = process.env;

export const openEmployerSignUp = ({
  posthog,
  buttonCTA,
  buttonColour,
  section,
}) => {
  const isStaging = process.env.NEXT_PUBLIC_JSW_ENV !== "prod";

  const isRegisterElp =
    localStorage.getItem("posthogRegisterELP") ?? "undefined";
  const currentPosition =
    localStorage.getItem("posthogPosition") ?? "undefined";
  const currentImage = localStorage.getItem("posthogImage") ?? "undefined";

  posthog.capture("request_a_free_demo", { origin: "pre-elp" });

  posthog.capture("elp_sign_up_click", {
    section: section,
    cta: buttonCTA,
    colour: buttonColour,
    promo_position: currentPosition,
    quality_talent_image: currentImage,
    is_elp_register: isRegisterElp,
  });

  sendTrackingEvent({
    event: "CE_elp_sign_up_click",
    section: section,
    cta: buttonCTA,
    colour: buttonColour,
    promo_position: currentPosition,
    quality_talent_image: currentImage,
    is_elp_register: isRegisterElp,
  });

  if (process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "sg") {
    return window.open("http://hub.hiredly.com/hiredly-sg-employer-waitlist");
  }

  let urlAndEnvParams = new URLSearchParams(window.location.search);

  urlAndEnvParams.append(
    "country",
    process.env.NEXT_PUBLIC_JSW_GEOLOCATION ?? "my"
  );
  urlAndEnvParams.append("env", process.env.NEXT_PUBLIC_JSW_ENV ?? "staging");
  urlAndEnvParams.append("origin", "jobseeker");
  urlAndEnvParams.append("section", section);
  urlAndEnvParams.append("cta", buttonCTA);
  urlAndEnvParams.append("colour", buttonColour);
  urlAndEnvParams.append("promo_position", currentPosition);
  urlAndEnvParams.append("quality_talent_image", currentImage);
  urlAndEnvParams.append("isElpRegister", isRegisterElp);
  // test

  const baseUrls = {
    staging: "https://staging-employer.hiredly.com/register/",
    production: "https://employer.hiredly.com/register/",
  };

  if (isRegisterElp == "true") {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  } else {
    if (isStaging) {
      if (buttonCTA == "Employer Log In") {
        window.location.assign(
          "https://staging-employer.hiredly.com/login/" + `?${urlAndEnvParams}`
        );
      } else {
        window.location.assign(baseUrls.staging + `?${urlAndEnvParams}`);
      }
    } else {
      if (buttonCTA == "Employer Log In") {
        window.location.assign(
          "https://employer.hiredly.com/login/" + `?${urlAndEnvParams}`
        );
      } else {
        window.location.assign(baseUrls.production + `?${urlAndEnvParams}`);
      }
    }
  }
};
